var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: "display: flex;width: 780px;" },
    [
      _c(
        "div",
        { staticClass: "form-column" },
        [
          _c("el-form", { staticClass: "result-form" }, [
            _c("table", { attrs: { cellpadding: "0", cellspacing: "0" } }, [
              _c("tr", [
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("FileHistory.fileName")))
                ]),
                _c("td", [
                  _c("span", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v(_vm._s(_vm.details.fileName))
                  ])
                ]),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.BusinessReferenceNo")))
                ]),
                _c(
                  "td",
                  [
                    _c("el-input", {
                      attrs: { no: "ourCompanyNo" },
                      model: {
                        value: _vm.resultJson.ourCompanyNo,
                        callback: function($$v) {
                          _vm.$set(_vm.resultJson, "ourCompanyNo", $$v)
                        },
                        expression: "resultJson.ourCompanyNo"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.SerialNo")))
                ]),
                _c("td", [
                  _c("span", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v(_vm._s(_vm.details.fileNo))
                  ])
                ]),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.BusinessNumber")))
                ]),
                _c("td", [
                  _c("span", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v(_vm._s(_vm.details.jobNo))
                  ])
                ])
              ]),
              _c("tr", [
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.ConsignationCompany")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "1" },
                            on: { change: _vm.mapperClient },
                            model: {
                              value: _vm.resultJson.client,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "client", $$v)
                              },
                              expression: "resultJson.client"
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-company-select", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          no: "2",
                          "method-params": {
                            customer: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.job.customerId || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.customerId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.WarehouseNo")))
                ]),
                _c(
                  "td",
                  [
                    _c("el-input", {
                      attrs: { no: "3" },
                      model: {
                        value: _vm.resultJson.warehouseReceiptNo,
                        callback: function($$v) {
                          _vm.$set(_vm.resultJson, "warehouseReceiptNo", $$v)
                        },
                        expression: "resultJson.warehouseReceiptNo"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
                  _vm._v(_vm._s(_vm.$t("Message.Shipper")))
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "4" },
                          model: {
                            value: _vm.job.shipperLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine1", $$v)
                            },
                            expression: "job.shipperLine1"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.BLForm")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "5" },
                            on: { change: _vm.mapperBlType },
                            model: {
                              value: _vm.resultJson.orderType,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "orderType", $$v)
                              },
                              expression: "resultJson.orderType"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { no: "6" },
                          model: {
                            value: _vm.job.orderType,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "orderType", $$v)
                            },
                            expression: "job.orderType"
                          }
                        },
                        _vm._l(_vm.blModeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name,
                              value: item.serialNumber
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "7" },
                          model: {
                            value: _vm.job.shipperLine2,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine2", $$v)
                            },
                            expression: "job.shipperLine2"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.LCL")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "8" },
                            on: { change: _vm.mapperLoadType },
                            model: {
                              value: _vm.resultJson.fclOrLcl,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "fclOrLcl", $$v)
                              },
                              expression: "resultJson.fclOrLcl"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { no: "9" },
                          model: {
                            value: _vm.job.containerLoadType,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "containerLoadType", $$v)
                            },
                            expression: "job.containerLoadType"
                          }
                        },
                        _vm._l(_vm.containerLoadTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "10" },
                          model: {
                            value: _vm.job.shipperLine3,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine3", $$v)
                            },
                            expression: "job.shipperLine3"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.ShippingCompany")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "11" },
                            on: { change: _vm.mapperShipName },
                            model: {
                              value: _vm.resultJson.shipName,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "shipName", $$v)
                              },
                              expression: "resultJson.shipName"
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-company-select", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          no: "12",
                          "method-params": {
                            companyLob: "seaExport",
                            seaCmp: true,
                            active: true
                          },
                          "default-value": _vm.job.carrierId || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.carrierId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "13" },
                          model: {
                            value: _vm.job.shipperLine4,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine4", $$v)
                            },
                            expression: "job.shipperLine4"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("Payment.vessel")))
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "14" },
                          model: {
                            value: _vm.resultJson.vessel,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "vessel", $$v)
                            },
                            expression: "resultJson.vessel"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "15" },
                          model: {
                            value: _vm.job.shipperLine5,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine5", $$v)
                            },
                            expression: "job.shipperLine5"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("Payment.voyage")))
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "16" },
                          model: {
                            value: _vm.resultJson.voyage,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "voyage", $$v)
                            },
                            expression: "resultJson.voyage"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "17" },
                          model: {
                            value: _vm.job.shipperLine6,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine6", $$v)
                            },
                            expression: "job.shipperLine6"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("queryJob.dateOfDeparture")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "18" },
                            on: { change: _vm.mapperEtd },
                            model: {
                              value: _vm.resultJson.etd,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "etd", $$v)
                              },
                              expression: "resultJson.etd"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-date-picker", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          no: "19",
                          value: _vm.job.etd,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { input: _vm.etdChange }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "20" },
                          model: {
                            value: _vm.job.shipperLine7,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine7", $$v)
                            },
                            expression: "job.shipperLine7"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { attrs: { colspan: "2" } })
              ]),
              _c("tr", [
                _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
                  _vm._v(_vm._s(_vm.$t("Message.Consignee")))
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "21" },
                          model: {
                            value: _vm.job.consigneeLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine1", $$v)
                            },
                            expression: "job.consigneeLine1"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.TransportationClause")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "22" },
                            on: { change: _vm.mapperFreightTerm },
                            model: {
                              value: _vm.resultJson.serviceTerm,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "serviceTerm", $$v)
                              },
                              expression: "resultJson.serviceTerm"
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          no: "23",
                          "select-type":
                            _vm.selectTypeNames.basic_data_ShippingTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.freightTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.freightTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "24" },
                          model: {
                            value: _vm.job.consigneeLine2,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine2", $$v)
                            },
                            expression: "job.consigneeLine2"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.FreightTerm")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "25" },
                            on: { change: _vm.mapperPaymentTerm },
                            model: {
                              value: _vm.resultJson.paymenTerm,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "paymenTerm", $$v)
                              },
                              expression: "resultJson.paymenTerm"
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          no: "26",
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.paymentTermMBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.paymentTermMBL = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "27" },
                          model: {
                            value: _vm.job.consigneeLine3,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine3", $$v)
                            },
                            expression: "job.consigneeLine3"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.ContainerSize")))
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "28" },
                          model: {
                            value: _vm.resultJson.boxType,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "boxType", $$v)
                            },
                            expression: "resultJson.boxType"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "29" },
                          model: {
                            value: _vm.job.consigneeLine4,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine4", $$v)
                            },
                            expression: "job.consigneeLine4"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.ContainerAmount")))
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "30" },
                          model: {
                            value: _vm.resultJson.boxVolume,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "boxVolume", $$v)
                            },
                            expression: "resultJson.boxVolume"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "31" },
                          model: {
                            value: _vm.job.consigneeLine5,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine5", $$v)
                            },
                            expression: "job.consigneeLine5"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("queryJob.IncoTerm")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "32" },
                            on: { change: _vm.mapperIncoTerm },
                            model: {
                              value: _vm.resultJson.deliveryTerm,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "deliveryTerm", $$v)
                              },
                              expression: "resultJson.deliveryTerm"
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          no: "33",
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.incoTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.incoTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "34" },
                          model: {
                            value: _vm.job.consigneeLine6,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine6", $$v)
                            },
                            expression: "job.consigneeLine6"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("Payment.contactPerson")))
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "35" },
                          model: {
                            value: _vm.resultJson.contacts,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "contacts", $$v)
                            },
                            expression: "resultJson.contacts"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "36" },
                          model: {
                            value: _vm.job.consigneeLine7,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine7", $$v)
                            },
                            expression: "job.consigneeLine7"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { attrs: { colspan: "2" } })
              ]),
              _c("tr", [
                _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
                  _vm._v(_vm._s(_vm.$t("Message.Notify")))
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "37" },
                          model: {
                            value: _vm.job.notifyLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine1", $$v)
                            },
                            expression: "job.notifyLine1"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.CargoSize")))
                ]),
                _c("td", { attrs: { rowspan: "7" } }, [
                  _c(
                    "div",
                    { staticStyle: { position: "relative" } },
                    [
                      !_vm.showGoods
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                position: "absolute",
                                top: "0",
                                right: "0",
                                color: "deepskyblue",
                                "z-index": "1"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onMultDoc()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.MultipleMode")))]
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              resize: "none",
                              rows: 11,
                              no: "38"
                            },
                            model: {
                              value: _vm.resultJson.goodSize,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "goodSize", $$v)
                              },
                              expression: "resultJson.goodSize"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "39" },
                          model: {
                            value: _vm.job.notifyLine2,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine2", $$v)
                            },
                            expression: "job.notifyLine2"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "40" },
                          model: {
                            value: _vm.job.notifyLine3,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine3", $$v)
                            },
                            expression: "job.notifyLine3"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "41" },
                          model: {
                            value: _vm.job.notifyLine4,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine4", $$v)
                            },
                            expression: "job.notifyLine4"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "42" },
                          model: {
                            value: _vm.job.notifyLine5,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine5", $$v)
                            },
                            expression: "job.notifyLine5"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "43" },
                          model: {
                            value: _vm.job.notifyLine6,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine6", $$v)
                            },
                            expression: "job.notifyLine6"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: { no: "44" },
                          model: {
                            value: _vm.job.notifyLine7,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine7", $$v)
                            },
                            expression: "job.notifyLine7"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("Payment.portOfLoading")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "45" },
                            on: {
                              change: function($event) {
                                return _vm.mapperSeaPort(
                                  "loadingPortCode",
                                  "portOfLoading"
                                )
                              }
                            },
                            model: {
                              value: _vm.resultJson.portOfLoading,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "portOfLoading", $$v)
                              },
                              expression: "resultJson.portOfLoading"
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "180px" },
                        attrs: {
                          no: "46",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.job.loadingPortCode,
                          "tag-name": "englishName"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.loadingPortCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("Payment.portOfTransfer")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "47" },
                            on: {
                              change: function($event) {
                                return _vm.mapperSeaPort(
                                  "transferPortCode",
                                  "transitPort"
                                )
                              }
                            },
                            model: {
                              value: _vm.resultJson.transitPort,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "transitPort", $$v)
                              },
                              expression: "resultJson.transitPort"
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "180px" },
                        attrs: {
                          no: "48",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.job.transferPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.transferPortCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c("tr", [
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("queryJob.dischargingPortCode")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "49" },
                            on: {
                              change: function($event) {
                                return _vm.mapperSeaPort(
                                  "dischargingPortCode",
                                  "portOfDischarge"
                                )
                              }
                            },
                            model: {
                              value: _vm.resultJson.portOfDischarge,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "portOfDischarge", $$v)
                              },
                              expression: "resultJson.portOfDischarge"
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "180px" },
                        attrs: {
                          no: "50",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.job.dischargingPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.dischargingPortCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("queryJob.placeOfDelivery")))
                ]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "mapperClass" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { no: "51" },
                            on: {
                              change: function($event) {
                                return _vm.mapperSeaPort(
                                  "destinationPortCode",
                                  "placeOfDelivery"
                                )
                              }
                            },
                            model: {
                              value: _vm.resultJson.placeOfDelivery,
                              callback: function($$v) {
                                _vm.$set(_vm.resultJson, "placeOfDelivery", $$v)
                              },
                              expression: "resultJson.placeOfDelivery"
                            }
                          })
                        ],
                        1
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "180px" },
                        attrs: {
                          no: "52",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.job.destinationPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.destinationPortCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              !_vm.showGoods
                ? _c("tr", [
                    _c("td", { staticClass: "header" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
                    ]),
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { no: "53" },
                              model: {
                                value: _vm.resultJson.numberOfPieces,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.resultJson,
                                    "numberOfPieces",
                                    $$v
                                  )
                                },
                                expression: "resultJson.numberOfPieces"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("td", { staticClass: "header" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.Package")))
                    ]),
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "mapperClass" },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: { no: "54" },
                                on: { change: _vm.mapperPacking },
                                model: {
                                  value: _vm.resultJson.packing,
                                  callback: function($$v) {
                                    _vm.$set(_vm.resultJson, "packing", $$v)
                                  },
                                  expression: "resultJson.packing"
                                }
                              })
                            ],
                            1
                          ),
                          _c("cargo-packing-select", {
                            staticStyle: { width: "180px" },
                            attrs: { "default-value": _vm.job.packing },
                            on: {
                              change: function(p) {
                                _vm.job.packing = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              !_vm.showGoods
                ? _c("tr", [
                    _c("td", { staticClass: "header" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.Weight")))
                    ]),
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { no: "55" },
                              model: {
                                value: _vm.resultJson.grossWeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.resultJson, "grossWeight", $$v)
                                },
                                expression: "resultJson.grossWeight"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("td", { staticClass: "header" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))
                    ]),
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { no: "56" },
                              model: {
                                value: _vm.resultJson.volume,
                                callback: function($$v) {
                                  _vm.$set(_vm.resultJson, "volume", $$v)
                                },
                                expression: "resultJson.volume"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c("tr", [
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.Marks")))
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            resize: "none",
                            rows: 10,
                            no: "57"
                          },
                          model: {
                            value: _vm.resultJson.marks,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "marks", $$v)
                            },
                            expression: "resultJson.marks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("td", { staticClass: "header" }, [
                  _vm._v(_vm._s(_vm.$t("Pricing.Goods")))
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            resize: "none",
                            rows: 10,
                            no: "58"
                          },
                          model: {
                            value: _vm.resultJson.goodName,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "goodName", $$v)
                            },
                            expression: "resultJson.goodName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              !_vm.showGoods
                ? _c("tr", [
                    _c("td", { staticClass: "header" }, [
                      _vm._v(_vm._s(_vm.$t("Payment.remarks")))
                    ]),
                    _c(
                      "td",
                      { attrs: { colspan: "3" } },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                resize: "none",
                                rows: 5,
                                no: "59"
                              },
                              model: {
                                value: _vm.resultJson.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.resultJson, "remarks", $$v)
                                },
                                expression: "resultJson.remarks"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]),
            _vm.showGoods
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-top": "10px" },
                        attrs: {
                          disabled: _vm.readOnly,
                          type: "primary",
                          no: "60"
                        },
                        on: {
                          click: function($event) {
                            return _vm.addGoods()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Information.Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: _vm.readOnly,
                          type: "primary",
                          no: "61"
                        },
                        on: {
                          click: function($event) {
                            return _vm.deleteGoods()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Information.Delete")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: _vm.readOnly,
                          type: "primary",
                          no: "62"
                        },
                        on: {
                          click: function($event) {
                            return _vm.noExchange()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.NumberExchange")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: _vm.readOnly,
                          type: "primary",
                          no: "63"
                        },
                        on: {
                          click: function($event) {
                            return _vm.updateMode()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ReturnMode")))]
                    ),
                    _c("cargo-ag-grid", {
                      staticStyle: {
                        width: "100%",
                        height: "200px",
                        "margin-top": "10px"
                      },
                      attrs: {
                        "show-side-bar": false,
                        "grid-options": _vm.goods.gridOptions,
                        "column-defs": _vm.goodsColumnDefs,
                        "row-data": _vm.goods.rowData
                      },
                      on: {
                        gridReady: function(params) {
                          _vm.goods.gridApi = params.api
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm.showOtherField
        ? _c(
            "div",
            {
              staticClass: "section form-column",
              staticStyle: { "padding-top": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "85px", "label-position": "right" } },
                [
                  _c("div", { staticStyle: { "padding-bottom": "15px" } }, [
                    _c(
                      "span",
                      [
                        _vm._v(_vm._s(_vm.$t("SeaExport.OcrOtherInfo")) + " "),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom",
                              width: "400",
                              trigger: "hover"
                            }
                          },
                          [
                            _c("div", { staticClass: "pop-content" }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.OcrTip")))
                            ]),
                            _c("svg-icon", {
                              staticStyle: {
                                "font-size": "14px",
                                "margin-top": "-3px"
                              },
                              attrs: {
                                slot: "reference",
                                "icon-class": "question"
                              },
                              slot: "reference"
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._l(_vm.expressList, function(item) {
                    return _c(
                      "el-form-item",
                      {
                        key: item.name,
                        attrs: {
                          label: _vm.ColumnUtils.columnLabelFunc(
                            _vm.SystemConstants.OCR_FIELDS,
                            item.name
                          )
                        }
                      },
                      [
                        item.name === "cargoSource"
                          ? _c(
                              "el-select",
                              {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  no: "64",
                                  placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                  size: "mini"
                                },
                                model: {
                                  value: _vm.job.cargoSource,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cargoSource", $$v)
                                  },
                                  expression: "job.cargoSource"
                                }
                              },
                              _vm._l(
                                _vm.SystemConstants.CARGO_SOURCES,
                                function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.isZh
                                        ? item.chineseName
                                        : item.englishName,
                                      value: item.code
                                    }
                                  })
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                        item.name === "arriveDate"
                          ? _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "65",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm:ss"
                              },
                              model: {
                                value: _vm.job.arriveDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "arriveDate", $$v)
                                },
                                expression: "job.arriveDate"
                              }
                            })
                          : _vm._e(),
                        item.name === "customCutoff"
                          ? _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "66",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm:ss"
                              },
                              model: {
                                value: _vm.job.customCutoff,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "customCutoff", $$v)
                                },
                                expression: "job.customCutoff"
                              }
                            })
                          : _vm._e(),
                        item.name === "customerCutoff"
                          ? _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "67",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm:ss"
                              },
                              model: {
                                value: _vm.job.customerCutoff,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "customerCutoff", $$v)
                                },
                                expression: "job.customerCutoff"
                              }
                            })
                          : _vm._e(),
                        item.name === "customerShutout"
                          ? _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "68",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm:ss"
                              },
                              model: {
                                value: _vm.job.customerShutout,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "customerShutout", $$v)
                                },
                                expression: "job.customerShutout"
                              }
                            })
                          : _vm._e(),
                        item.name === "customerFileCutoff"
                          ? _c("el-date-picker", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "69",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm:ss"
                              },
                              model: {
                                value: _vm.job.customerFileCutoff,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "customerFileCutoff", $$v)
                                },
                                expression: "job.customerFileCutoff"
                              }
                            })
                          : _vm._e(),
                        item.name === "csr"
                          ? _c("cargo-user-select", {
                              ref: "csr",
                              refInFor: true,
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "70",
                                "method-params": {
                                  category: "role",
                                  shape: "csr"
                                },
                                "default-value": _vm.job.csr || "",
                                "merge-load": true
                              },
                              on: {
                                change: function(p) {
                                  _vm.csrChangeHandler(p)
                                }
                              }
                            })
                          : _vm._e(),
                        item.name === "dc"
                          ? _c("cargo-user-select", {
                              ref: "dc",
                              refInFor: true,
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "71",
                                "method-params": {
                                  category: "role",
                                  shape: "doc"
                                },
                                "default-value": _vm.job.dc || "",
                                "merge-load": true
                              },
                              on: {
                                change: function(p) {
                                  _vm.dcChangeHandler(p)
                                }
                              }
                            })
                          : _vm._e(),
                        item.name === "insideQuantity"
                          ? _c("auto-number-input", {
                              staticStyle: { width: "150px" },
                              attrs: { no: "72", precision: 0, min: 0 },
                              on: {
                                valCallBack: function(val) {
                                  _vm.job.insideQuantity = val
                                }
                              },
                              model: {
                                value: _vm.job.insideQuantity,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "insideQuantity", $$v)
                                },
                                expression: "job.insideQuantity"
                              }
                            })
                          : _vm._e(),
                        item.name === "insidePacking"
                          ? _c("cargo-packing-select", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                no: "73",
                                "default-value": _vm.job.insidePacking
                              },
                              on: {
                                change: function(p) {
                                  _vm.job.insidePacking = p.value
                                }
                              }
                            })
                          : _vm._e(),
                        item.name === "chargeWeight"
                          ? _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("auto-number-input", {
                                  staticStyle: { flex: "1", width: "135px" },
                                  attrs: { no: "74", precision: 3, min: 0 },
                                  on: {
                                    valCallBack: function(val) {
                                      _vm.job.chargeWeight = val
                                    }
                                  },
                                  model: {
                                    value: _vm.job.chargeWeight,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "chargeWeight", $$v)
                                    },
                                    expression: "job.chargeWeight"
                                  }
                                }),
                                _c("span", [_vm._v("M/T")])
                              ],
                              1
                            )
                          : _vm._e(),
                        item.name === "userDefinedField1"
                          ? _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { no: "75", type: "textarea", rows: 5 },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.UserDefinedField1"),
                                    _vm.job.userDefinedField1,
                                    function(val) {
                                      _vm.job.userDefinedField1 = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.userDefinedField1,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "userDefinedField1", $$v)
                                },
                                expression: "job.userDefinedField1"
                              }
                            })
                          : _vm._e(),
                        item.name === "userDefinedField2"
                          ? _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { no: "76", type: "textarea", rows: 5 },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.UserDefinedField2"),
                                    _vm.job.userDefinedField2,
                                    function(val) {
                                      _vm.job.userDefinedField2 = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.userDefinedField2,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "userDefinedField2", $$v)
                                },
                                expression: "job.userDefinedField2"
                              }
                            })
                          : _vm._e(),
                        item.name === "userDefinedField3"
                          ? _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { no: "77", type: "textarea", rows: 5 },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.UserDefinedField3"),
                                    _vm.job.userDefinedField3,
                                    function(val) {
                                      _vm.job.userDefinedField3 = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.userDefinedField3,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "userDefinedField3", $$v)
                                },
                                expression: "job.userDefinedField3"
                              }
                            })
                          : _vm._e(),
                        item.name === "userDefinedField4"
                          ? _c("el-input", {
                              staticStyle: { width: "150px" },
                              attrs: { no: "78", type: "textarea", rows: 5 },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.UserDefinedField4"),
                                    _vm.job.userDefinedField4,
                                    function(val) {
                                      _vm.job.userDefinedField4 = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.userDefinedField4,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "userDefinedField4", $$v)
                                },
                                expression: "job.userDefinedField4"
                              }
                            })
                          : _vm._e(),
                        item.name === "cargoChineseName"
                          ? _c("cargo-rich-textarea", {
                              staticStyle: { height: "110px" },
                              attrs: {
                                no: "cargoChineseName",
                                "auto-uppercase": false,
                                "auto-half-word": false,
                                "wrap-symbol": "r"
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t(
                                      "SeaExport.ChineseDescriptionOfGoods"
                                    ),
                                    _vm.job.cargoChineseName,
                                    function(val) {
                                      _vm.job.cargoChineseName = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.cargoChineseName,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cargoChineseName", $$v)
                                },
                                expression: "job.cargoChineseName"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  _vm.job.cargoSource === _vm.CargoSource.NC_CARGO_SOURCE.code
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.NCReferenceNo") } },
                        [
                          _c("el-input", {
                            attrs: { no: "agentRefNo" },
                            model: {
                              value: _vm.job.agentRefNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "agentRefNo", $$v)
                              },
                              expression: "job.agentRefNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogConfirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      return _vm.closeAdvanceText()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }